import type {
  GetVacancyStatusesHistoryRequest,
  VacancyStatusesHistory,
} from '../types';
import { vacancyApi } from '../vacancyApi';
import { QueryKey } from '@shared/config';
import { useInfiniteRequest } from '@shared/config/query/hooks';
import { keepPreviousData } from '@tanstack/react-query';

export const useGetVacancyStatusesHistory = (
  id: number,
  params: GetVacancyStatusesHistoryRequest
) => {
  return useInfiniteRequest<VacancyStatusesHistory>({
    queryKey: [QueryKey.GET_VACANCY_STATUS_HISTORY, params, id],
    queryFn: ({ pageParam }) =>
      vacancyApi.getVacancyStatusesHistory(id, { ...params, ...pageParam }),
    initialPageParam: {
      perPage: params.perPage,
      page: params.page,
    },
    placeholderData: keepPreviousData,
  });
};
